// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__vzp86","title":"Header_title__8yBVH","side":"Header_side__13yBa"};